import { ReactFramework as Framework } from "./templateProjects";

/**
 * IMPORTANT: This file is synced between web/api, if changing copy it into the other repo
 * You can keep the imports above as they are different between client/api
 */

const simpleResolve = (path: string, otherPath: string) => {
  const combinedPath =
    path.replace(/\/+/g, "/") + otherPath.replace(/\/+/g, "/");
  return combinedPath.replace(/\/+/g, "/");
};

/**
 * After creating a storyboard, get the file path for tempobook
 */
export const getTempobookUrlFilePath = (
  canvasId: string,
  projectData: any,
  fullFilePath: string,
  storybookComponentName?: string
) => {
  if (
    !projectData ||
    projectData.framework === Framework.REMIX ||
    projectData.framework === Framework.VITE_REACT_ROUTER_V7
  ) {
    let urlPathToReturn;

    if (fullFilePath.includes("/routes/")) {
      // Get the file path after the routes folder and remove the extension
      urlPathToReturn = fullFilePath.split("/routes")[1];
    } else {
      urlPathToReturn = "/tempobook/dynamic" + fullFilePath.split(canvasId)[1];
    }

    // Remove the extension
    urlPathToReturn = urlPathToReturn.split(".").slice(0, -1).join(".");

    // Remove _index prefix
    if (urlPathToReturn.endsWith("_index")) {
      urlPathToReturn = urlPathToReturn.slice(0, urlPathToReturn.length - 6);
    }

    urlPathToReturn = urlPathToReturn
      // Convert to expected path
      .replace("|", "")
      .replace(/\./g, "/");

    if (storybookComponentName) {
      urlPathToReturn += `/${storybookComponentName}`;
    }

    return urlPathToReturn;
  }

  let urlPathToReturn = "/tempobook/dynamic" + fullFilePath.split(canvasId)[1];

  if (storybookComponentName) {
    urlPathToReturn += `/${storybookComponentName}`;
  }

  if (
    projectData.framework === Framework.VITE ||
    projectData.framework === Framework.VITE_WITH_VIKE
  ) {
    // For vite, we only want to remove the sub-path for storyboards, because they are inside tempobook/storyboards
    // Thus, a path like src/tempobook/storyboards/<id>/index.tsx won't get added to src/tempobook/dynamic/src/tempobook/storyboards/<id>/index.tsx
    // However, for all else they will be added to src/tempobook/dynamic/src/etc
    if (fullFilePath.includes("tempobook/storyboards")) {
      urlPathToReturn =
        "/tempobook/storyboards/" +
        urlPathToReturn.split("/tempobook/storyboards/")[1];
    }

    // Remove the extension if it's at the end
    if (urlPathToReturn.lastIndexOf(".") > urlPathToReturn.lastIndexOf("/")) {
      urlPathToReturn = urlPathToReturn.substring(
        0,
        urlPathToReturn.lastIndexOf(".")
      );
    }

    if (urlPathToReturn.endsWith("/index")) {
      urlPathToReturn = urlPathToReturn.split("/index")[0];
    } else if (urlPathToReturn.endsWith("/+Page")) {
      urlPathToReturn = urlPathToReturn.split("/+Page")[0];
    }

    // Replace all periods with dashes (not supported in the vite plugin pages)
    urlPathToReturn = urlPathToReturn.replace(/\./g, "-");

    return urlPathToReturn;
  }

  // For next.js we need to remove the pages sub-path because we do not create dynamic routes
  // for those components.
  // E.g. pages/components/test.tsx will not create a route /pages/tempobook/dynamic/pages/components/test.sx
  // as you can just hit /components/test.tsx to render this component
  //
  // Expo works the same as app router except the pages are just index.tsx files
  if (
    projectData.framework === Framework.NEXT_JS ||
    projectData.framework === Framework.NEXT_JS_APP_ROUTER ||
    projectData.framework === Framework.EXPO
  ) {
    // Default folders to search
    let possiblePagesSubpaths = ["pages", "app"];

    // Map to the expected folder
    possiblePagesSubpaths = possiblePagesSubpaths.map((subpath) => {
      return simpleResolve(projectData.projectSubfolderPath || "/", subpath);
    });

    if (projectData.srcFolderPath) {
      possiblePagesSubpaths.push(
        simpleResolve(projectData.srcFolderPath, "pages")
      );
    }

    if (projectData.mainFilePath) {
      const fullDir = projectData.mainFilePath
        .split("/")
        .slice(0, -1)
        .join("/");
      possiblePagesSubpaths.push(fullDir);
    }

    // Find the first matching subpath
    for (var i = 0; i < possiblePagesSubpaths.length; i += 1) {
      const possiblePagesSubpath = possiblePagesSubpaths[i];
      if (urlPathToReturn.indexOf(possiblePagesSubpath) > -1) {
        urlPathToReturn = urlPathToReturn.split(possiblePagesSubpath)[1];

        // Remove the extension
        urlPathToReturn = urlPathToReturn.substring(
          0,
          urlPathToReturn.lastIndexOf(".")
        );

        break;
      }
    }

    if (
      projectData.framework === Framework.NEXT_JS &&
      urlPathToReturn.endsWith("/index")
    ) {
      urlPathToReturn = urlPathToReturn.split("/index")[0];
    } else if (
      projectData.framework === Framework.NEXT_JS_APP_ROUTER &&
      urlPathToReturn.endsWith("/page")
    ) {
      urlPathToReturn = urlPathToReturn.split("/page")[0];
    } else if (
      projectData.framework === Framework.EXPO &&
      urlPathToReturn.endsWith("/index")
    ) {
      urlPathToReturn = urlPathToReturn.split("/index")[0];
    }

    return urlPathToReturn;
  }

  return urlPathToReturn;
};
